import {
  applicationService,
  bankService,
  districtService,
  houseCategoryService,
  houseRangeService,
  upiService,
  loanService,
  myLoanService,
  loanApplicationService,
  specificLoanApplicationService,
  downloadService,
  zipDownloadService,
  changeApplicationStatus,
  commentApplication,
  downloadDocument,
  downloadApplicantDocument,
  downloadApplicantZipDocument,
  bankStatsService,
} from '../../services/applicationService';
import {
  APPLICATION,
  BANKS,
  DISTRICT,
  HOUSE_CATEGORY,
  HOUSE_RANGE,
  UPI,
  LOAN,
  MY_LOAN,
  LOANS_APPLICATIONS,
  SPECIFIC_LOAN_APPLICATION,
  CERTIFICATE,
  ZIP_CERTIFICATE,
  BANK_STATS,
  CLEAR_NEW_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_NOTIFICATIONS_REQUEST,
  MARK_NOTIFICATIONS_AS_SEEN,
  FETCH_UNSEEN_NOTIFICATIONS_SUCCESS,
  MARK_NOTIFICATION_AS_SEEN,
} from './actiontype';
import {
  CHANGE_APPLICATION_STATUS,
  COMMENT_APPLICATION,
  DOWNLOAD_DOCUMENT,
  DOWNLOAD_APPLICANT_DOCUMENT,
  DOWNLOAD_APPLICANT_ZIP_DOCUMENT,
} from 'redux/actionTypes';
import { notification } from 'antd';
import { downloadFile, fulfilled, pending } from 'utils';
import notificationService from 'services/notificationService';

export const districtAction = () => {
  return {
    type: DISTRICT,
    payload: districtService(),
  };
};

export const houseCategoryAction = () => {
  return {
    type: HOUSE_CATEGORY,
    payload: houseCategoryService(),
  };
};

export const houseRangeAction = (data) => {
  return {
    type: HOUSE_RANGE,
    payload: houseRangeService(data),
  };
};

export const bankAction = () => {
  return {
    type: BANKS,
    payload: bankService(),
  };
};

export const applicationAction = (data) => {
  return {
    type: APPLICATION,
    payload: applicationService(data),
  };
};

export const upiAction = (data) => {
  return {
    type: UPI,
    payload: upiService(data),
  };
};

export const loanAction = (data) => {
  return {
    type: LOAN,
    payload: loanService(data),
  };
};

export const myLoanAction = () => {
  return {
    type: MY_LOAN,
    payload: myLoanService(),
  };
};

export const loanApplicationAction = (data) => {
  return {
    type: LOANS_APPLICATIONS,
    payload: loanApplicationService(data),
  };
};

export const bankStatsAction = (bankId) => async (dispatch) => {
  try {
    dispatch({ type: BANK_STATS, payload: { loading: true } });
    const { data: body } = await bankStatsService(bankId);

    const { status, message, data } = body;

    if (status === 200) {
      dispatch({
        type: BANK_STATS,
        payload: {
          loading: false,
          status,
          message,
          data,
        },
      });
    } else {
      dispatch({
        type: BANK_STATS,
        payload: { loading: false, status: 'error' },
      });
    }
  } catch (error) {
    dispatch({
      type: BANK_STATS,
      payload: { loading: false, status: 'error' },
    });
  }
};

export const specificLoanApplicationAction = (id) => {
  return {
    type: SPECIFIC_LOAN_APPLICATION,
    payload: specificLoanApplicationService(id),
  };
};

export const downloadAction = (id, genre, certificateType) => {
  return {
    type: CERTIFICATE,
    payload: downloadService(id, genre, certificateType),
  };
};

export const zipDownloadAction = (id) => {
  return {
    type: ZIP_CERTIFICATE,
    payload: zipDownloadService(id),
  };
};

export const changeApplicationStatusAction =
  (id, action, level, payload) => async (dispatch) => {
    console.log('payload', level, action, id);
    try {
      dispatch({ type: CHANGE_APPLICATION_STATUS, payload: { loading: true } });
      const { data: body } = await changeApplicationStatus(
        id,
        action,
        level,
        payload
      );

      const { status, message, data } = body;

      if (status === 200) {
        notification.success({
          message: 'Success',
          description: `Application has been set to ${action}`,
        });
        dispatch({
          type: CHANGE_APPLICATION_STATUS,
          payload: {
            loading: false,
            status,
            message,
            data,
          },
        });
      } else {
        dispatch({
          type: CHANGE_APPLICATION_STATUS,
          payload: { loading: false, status: 'error' },
        });
      }
    } catch (error) {
      dispatch({
        type: CHANGE_APPLICATION_STATUS,
        payload: { loading: false, status: 'error' },
      });
    }
  };

export const commentApplicationAction =
  (id, user, payload) => async (dispatch) => {
    try {
      dispatch({
        type: pending(COMMENT_APPLICATION),
        payload: { loading: true },
      });
      const { data: body } = await commentApplication(id, user, payload);

      const { status, message, data } = body;

      if (status === 200) {
        notification.success({
          message: 'Success',
          description: `Comment has been posted`,
        });
        dispatch({
          type: fulfilled(COMMENT_APPLICATION),
          payload: {
            loading: false,
            status,
            message,
            data,
          },
        });
      } else {
        dispatch({
          type: rejected(COMMENT_APPLICATION),
          payload: { loading: false, status: 'error' },
        });
      }
      return data;
    } catch (error) {
      dispatch({
        type: COMMENT_APPLICATION,
        payload: { loading: false, status: 'error' },
      });
    }
  };

export const downloadDocumentAction =
  (applicationId, docId) => async (dispatch) => {
    try {
      dispatch({ type: DOWNLOAD_DOCUMENT, payload: { loading: true } });
      const { data: body } = await downloadDocument(applicationId, docId);

      const { status, message, data } = body;

      if (status === 200) {
        downloadFile(data);
        dispatch({
          type: DOWNLOAD_DOCUMENT,
          payload: {
            loading: false,
            status,
            message,
            data,
          },
        });
      } else {
        dispatch({
          type: DOWNLOAD_DOCUMENT,
          payload: { loading: false, status: 'error' },
        });
      }
    } catch (error) {
      dispatch({
        type: DOWNLOAD_DOCUMENT,
        payload: { loading: false, status: 'error' },
      });
    }
  };

export const downloadApplicantDocumentAction = (docId) => async (dispatch) => {
  try {
    dispatch({ type: DOWNLOAD_APPLICANT_DOCUMENT, payload: { loading: true } });
    const { data: body } = await downloadApplicantDocument(docId);

    const { status, message, data } = body;

    if (status === 200) {
      downloadFile(data);
      dispatch({
        type: DOWNLOAD_APPLICANT_DOCUMENT,
        payload: {
          loading: false,
          status,
          message,
          data,
        },
      });
    } else {
      dispatch({
        type: DOWNLOAD_APPLICANT_DOCUMENT,
        payload: { loading: false, status: 'error' },
      });
    }
  } catch (error) {
    dispatch({
      type: DOWNLOAD_APPLICANT_DOCUMENT,
      payload: { loading: false, status: 'error' },
    });
  }
};

export const downloadApplicantZipDocumentAction = () => async (dispatch) => {
  try {
    dispatch({
      type: DOWNLOAD_APPLICANT_ZIP_DOCUMENT,
      payload: { loading: true },
    });
    const { data: body } = await downloadApplicantZipDocument();

    const { status, message, data } = body;
    if (status === 200) {
      downloadFile(data);
      dispatch({
        type: DOWNLOAD_APPLICANT_ZIP_DOCUMENT,
        payload: {
          loading: false,
          status: 'success',
          message,
          data,
        },
      });
    } else {
      dispatch({
        type: DOWNLOAD_APPLICANT_ZIP_DOCUMENT,
        payload: { loading: false, status: 'error' },
      });
    }
  } catch (error) {
    dispatch({
      type: DOWNLOAD_APPLICANT_ZIP_DOCUMENT,
      payload: { loading: false, status: 'error' },
    });
  }
};



export const fetchNotifications = (userId) => async (dispatch) => {
  dispatch({ type: FETCH_NOTIFICATIONS_REQUEST });

  try {
    const notifications = await notificationService.getNotifications(userId);
    // console.log("Notifications", notifications);
    dispatch({ type: FETCH_NOTIFICATIONS_SUCCESS, payload: notifications });
  } catch (error) {
    dispatch({ type: FETCH_NOTIFICATIONS_FAILURE, payload: error.message });
  }
};

export const clearNewNotifications = () => ({
  type: CLEAR_NEW_NOTIFICATIONS,
});


export const fetchUnseenNotifications = (userId) => async (dispatch) => {
  try {
    const unseenNotifications = await notificationService.getUnseenNotifications(userId);
    dispatch({ type: FETCH_UNSEEN_NOTIFICATIONS_SUCCESS, payload: unseenNotifications.length });
  } catch (error) {
    console.error("Error fetching unseen notifications:", error);
  }
};


export const markNotificationsAsSeen = (userId) => async (dispatch) => {
  try {
    await notificationService.markNotificationsAsSeen(userId);
    dispatch({ type: MARK_NOTIFICATIONS_AS_SEEN });
  } catch (error) {
    console.error("Error marking notifications as seen:", error);
  }
};

export const markNotificationAsSeen = (userId, notificationId) => async (dispatch) => {
  try {
    await notificationService.markNotificationAsSeen(userId, notificationId);
    dispatch({ type: MARK_NOTIFICATION_AS_SEEN });
  } catch (error) {
    console.error("Error marking notifications as seen:", error);
  }
};